import PageTitle from "../../components/PageTitle/PageTitle";
import React from "react";

const NotFound = (props) => {
  return (
    <main>
      <PageTitle
        title="
          Not Found
        "
      />
    </main>
  );
};

export default NotFound;
